import React from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import HomePage from "./components/Home"
import HDForm from "./components/HDForm"
import { useAuth0 } from "@auth0/auth0-react"
import PrivateRoutes from "./components/privateRoutes"
import Spinner from "./components/Spinner"
import Generator from "./components/views/QrGenerator"
import Dashboard from "./components/admin/Dashboard"
import Profile from "./components/views/profile"
import AddFacilityForm from "./components/faciliities/AddFacilities"
import FacilityList from "./components/faciliities/FacilityList"
import QRPage from "./components/faciliities/QRPage"
import Terms from "./components/Terms"
import PrivacyPolicy from "./components/Policy"
import Footer from "./components/Footer"
import Logout from "./components/Logout"
import EditFacility from "./components/faciliities/EditFacility"
import FacilityDetails from "./components/faciliities/FacilityDetails"
import "./bootstrap.min.css"

function App() {
  const { isLoading } = useAuth0()

  if (isLoading) {
    return <Spinner />
  }
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/form/:id" component={HDForm} />
        <Route path="/qr" component={Generator} />

        <PrivateRoutes path="/admin" component={Dashboard} exact />
        <PrivateRoutes
          path="/admin/facility/register"
          component={AddFacilityForm}
          exact
        />
        <PrivateRoutes
          path="/admin/facility/edit/:id"
          component={EditFacility}
          exact
        />
        <PrivateRoutes
          path="/admin/facility/:id"
          component={FacilityDetails}
          exact
        />
        <PrivateRoutes path="/admin/facility/qr/:id" component={QRPage} exact />
        <PrivateRoutes path="/profile" component={Profile} />
        <Route path="/terms-of-use" component={Terms} />
        <Route path="/policy" component={PrivacyPolicy} />
        <PrivateRoutes path="/logout" component={Logout} />
      </Switch>
      <Footer />
    </Router>
  )
}

export default App
